// extracted by mini-css-extract-plugin
export default {"pageWrap":"ad-z","fullWidth":"bd-z","heading":"cd-z","fullBleed":"dd-z","hidden":"ed-z"};